<template>
  <div>
    <el-form label-position="top" :hide-required-asterisk="true" :rules="rules" ref="ruleForm"  label-width="80px" :model="formLabelAlign">
      <vue-dividing-line title="基本信息"></vue-dividing-line>
      <el-row :gutter="20" type="flex">
        <el-col :span="12">
          <el-form-item label="" prop="number" :rules="[
              { required: true, message: '',trigger: 'blur' },
            ]">
            <div slot="label">
              <div class="label-text">
                練習編號
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-input
              v-model="formLabelAlign.number"
              placeholder="請輸入學習重點編號"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="" prop="lang" :rules="[
              { required: true, message: '',trigger: 'blur' },
            ]">
            <div slot="label">
              <div class="label-text">
                課程版本
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-select v-model="formLabelAlign.lang" placeholder="請選擇課程版本">
              <el-option
                v-for="item in languages"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select> </el-form-item
        ></el-col>
      </el-row>
      <el-form-item label="" prop="describe" :rules="[
              { required: false, message: '',trigger: 'blur' },
            ]">
          <div slot="label">
              <div class="label-text">
                  描述
                  <!-- <span class="star-mark">*</span> -->
              </div>
          </div>
          <el-input
                v-model="formLabelAlign.desc"
                placeholder="請輸入描述"
              ></el-input>
      </el-form-item>
      <vue-dividing-line title="講解"></vue-dividing-line>
      <div style="margin-bottom:20px;">請選擇以下其中一項 <span class="star-mark"> *</span></div>
      <el-radio-group
        class="document-identity-radio"
        @input="radioChange"
        v-model="formLabelAlign.type"
      >
        <el-radio :label="0">
          <div style="margin-bottom:20px;">視頻 <span v-if="formLabelAlign.type == 0" class="star-mark">*</span></div>
          <el-form-item style="width:500px;" prop="guideVideoUrl"  :rules="[
              { required: formLabelAlign.type == 0, message: '',trigger: 'blur' },
            ]">
            <div v-show="formLabelAlign.type == 0" >
              <div v-if="formLabelAlign.guideVideoUrl">
                <videoPlayer :videoUrl="formLabelAlign.guideVideoUrl"></videoPlayer>
              </div>
              <div style="margin-top:20px;">
                 <div style="margin-bottom:10px;">
                    <el-button type="info"  class="browse-button" @click="onSelectFilmButton"> 請選擇影片</el-button>
                  </div>
                  <el-input style="width: 100%;" v-model="formLabelAlign.guideVideoUrl" placeholder="請輸入影片網址"></el-input>
              </div>
            </div>
          </el-form-item>
        </el-radio>
        <el-radio :label="1" style="width: fit-content;">
          <div style="margin-bottom:20px;">講解圖片<span v-show="formLabelAlign.type == 1" class="star-mark">*</span></div>
          <el-form-item prop="guideImageUrl" :rules="[
              { required: formLabelAlign.type == 1, message: '',trigger: 'blur' },
            ]">
            <el-row
              v-show="formLabelAlign.type == 1"
              type="flex"
              align="middle"
              :gutter="10"
            >
              <el-col :span="6">
                <upload @childByValue="childByValue"  :isImgUpload="true"  :imageurl="formLabelAlign.guideImageUrl" buttonText="瀏覽"></upload>
              </el-col>
            </el-row>
          </el-form-item>
        </el-radio>
      </el-radio-group>
      <vue-dividing-line title="練習題目"></vue-dividing-line>
      <el-row :gutter="20" type="flex">
        <el-col :span="12">
          <el-form-item label="" prop="randomNumber">
            <div slot="label">
              <div class="label-text">
                  <el-radio-group style="flex-direction: row;" @input="onRadioChange" v-model="formLabelAlign.isRandom">
                    <el-radio :label="false">順序顯示</el-radio>
                    <el-radio :label="true">隨機抽取</el-radio>
                  </el-radio-group>
              </div>
            </div>
            <el-input
              placeholder="請輸入隨機抽取數量"
              :disabled="!formLabelAlign.isRandom"
              v-model.number="formLabelAlign.randomNumber"
            ></el-input> </el-form-item
        ></el-col>
        <el-col :span="12">
          <el-form-item label="及格分數線" prop="passScore" :rules="[
              { required: true, message: '',trigger: 'blur' },
            ]">
            <div slot="label">
              <div class="label-text">
                及格分數線
                <span class="star-mark">*</span>
              </div>
            </div>
            <el-input
              placeholder="請輸入及格分數線"
              v-model="formLabelAlign.passScore"
            ></el-input> </el-form-item
        ></el-col>
      </el-row>
      <el-form-item prop="questions" :rules="[
          { required: true, message: '',trigger: 'blur',type: 'array'},
      ]">
        <div slot="label">
          <div class="label-text">
            題目
            <span class="star-mark">*</span>
          </div>
        </div>
        <draggable
          v-model="formLabelAlign.questions"
          @update="draggableUpdate"
          animation="300"
          handle=".mover"
        >
          <div
            v-for="(item, index) in formLabelAlign.questions"
            :key="index"
            class="unit-list"
          >
            <el-row type="flex" class="row-bg" :gutter="10">
              <el-col :span="6">
                <el-form-item label=""  :prop="'questions.' + index + '.id'" :rules="[
                  { required: true, message: '',trigger: 'blur' },
                ]">
                  <el-input
                  disabled
                  v-model="item.number"
                  placeholder=""
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="2" v-if="formLabelAlign.questions.length > 1"
                ><i class="el-icon-rank mover"></i
              ></el-col>
              <el-col :span="2" 
                ><i class="el-icon-close" @click="onIconClose(index)"></i
              ></el-col>
            </el-row>
          </div>
        </draggable>
      </el-form-item>
      <el-form-item>
        <span
          @click="onAdd"
          class="plus-outline-add text-line-button cursor-pointer"
        >
          <i class="icon iconfont icon-jiahao" />添加更多題目
        </span>
      </el-form-item>
    </el-form>
    <dialogSlotVisible :centerDialogVisible="centerDialogVisible">
          <materialDialog @iconClose="iconClose" @childVideoUrl="childVideoUrl"></materialDialog>
    </dialogSlotVisible>
    <dialogSlotVisible :centerDialogVisible="centerDialogVisibleQuestion">
          <questionItem @select="select" @iconClose="iconCloseSelect"></questionItem>
    </dialogSlotVisible>
  </div>
</template>

<script>
import dialogSlotVisible from "@/components/dialogSlotVisible";
import materialDialog from './materialDialog'
import questionItem from './questionItem'
import videoPlayer from './videoPlayer'
import upload from "@/components/upload";
import draggable from "vuedraggable";
export default {
  components: { draggable, upload,videoPlayer,materialDialog,dialogSlotVisible,questionItem},
  props: {
    formLabelAlign: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    var validateRandomNumber = (rule, value, callback) =>{
      let newNumber = Number(value)
      if(this.formLabelAlign.isRandom &&  (newNumber <1 || (newNumber > this.formLabelAlign.questions.length))){
        callback(new Error('隨機題數不能大於題目數量 或 小于1'));
      }else {
        callback()
      }
    }
    return {
      questionIndex: 0,
      centerDialogVisibleQuestion:false,
      centerDialogVisible:false,
      videoFileType: ['avi','mp4','mov','mkv','flv','wmv','rmvb','mpeg','m4v','asf','f4v','rm','3gp','vob'],
      questionLits:[],
      rules:{
        randomNumber: [
          { required: this.formLabelAlign.isRandom, type: 'number',  message: '', },
          { validator: validateRandomNumber, trigger: 'blur' },
        ],
      },
      units: [],
    };
  },
  methods: {
    onRadioChange(){
      if(!this.formLabelAlign.isRandom){
        this.formLabelAlign.randomNumber = 0
        this.$forceUpdate()
      }
    },
    iconCloseSelect(){
      this.centerDialogVisibleQuestion = false
    },
    select(value){
      let selectValue = {
          id:value.id,
          number:value.questionNo
        }
      this.formLabelAlign.questions.push(selectValue);
      this.centerDialogVisibleQuestion = false
      this.$forceUpdate()
    },
    onSelectButton(index){
      this.questionIndex = index
      this.centerDialogVisibleQuestion = true
    },
    iconClose(){
      this.centerDialogVisible = false
    },
    onSelectFilmButton(){
      this.centerDialogVisible = true
    },
    childVideoUrl(v){
      this.formLabelAlign.guideVideoUrl = v;
      this.centerDialogVisible = false
      this.$forceUpdate();
    },
    radioChange(){
      this.$forceUpdate()
    },
    childByValue(v){
      this.formLabelAlign.guideImageUrl = v
      this.$forceUpdate()
    },
    onIconClose(index){
       this.formLabelAlign.questions.splice(index, 1)
    },
    draggableUpdate(){},
    onAdd() {
      this.centerDialogVisibleQuestion = true
    },
    childByVideoUrl(v) {
      this.formLabelAlign.guideVideoUrl = v;
      this.$forceUpdate();
    }
  },
};
</script>

<style lang="scss" scoped>
.unit-list {
  margin-bottom: 20px;
}
.document-identity-radio .el-radio {
  display: inline-flex;
  margin-bottom: 20px;
  width: min-content;
}
::v-deep {
  .el-radio-group {
    display: inline-flex;
    flex-direction: column;
  }
  .el-select {
    width: 100%;
  }
}
</style>